import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, plate, rib, mergeBones, stages, boneG } from './kit';
/* ============================================================
   HOHLRAUM 空腔 —— BOSS・無骨架
   ============================================================

   剪影：十八片浮空板・中心是一個洞
   階段：'P1 板貼合成殼・像個機械','P2 板散開・洞變大','P3 板翻面穿過核心・把自己吞進去'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-19 HOHLRAUM 空腔 ── 沒有骨架。
   十八片裝甲板浮在該有關節的地方，板與板之間、板與核心之間什麼都沒有。
   中心是一顆 MeshBasicMaterial 的死黑八面體 —— 不受光，讀作「這裡被挖掉了」。
   P1 板貼合成殼、看起來像個機械。P2 板散開、殼破了、洞變大。
   P3 板整片翻面朝內並穿過核心 —— 它把自己吞進去。 */
export function buildHohlraum(){
  var GLV = glowMat(TINT.vio.hex, 2.5), GLA = glowMat(TINT.amb.hex, 2.2);
  var root = new THREE.Group(), plates = [], i, k;
  var hub = boneG(root, 0, 3.90, 0);
  var vd = mesh(G.oct, M.void, [2.60,2.60,2.60], [0,0,0]);
  vd.userData.noMerge = 1; hub.add(vd);
  var rim = mesh(G.tor, GLV, [3.20,3.20,0.34], [0,0,0], [HP,0,0]);
  rim.userData.noMerge = 1; hub.add(rim);
  var rim2 = mesh(G.tor, GLV, [3.00,3.00,0.30], [0,0,0], [0,HP,0]);
  rim2.userData.noMerge = 1; hub.add(rim2);
  var RY = [1.55, 0, -1.55], RT = [-0.62, 0, 0.62], RS = [0.66, 1.00, 0.66];
  for (k = 0; k < 3; k++){
    for (i = 0; i < 6; i++){
      var a = i*Math.PI * 2/6 + k*0.36;
      var az = boneG(hub, 0, 0, 0); az.rotation.y = a;
      var pl = boneG(az, 0, RY[k], 2.70*RS[k]);
      pl.rotation.x = RT[k];
      pl.add(plate(M.armor, 1.85*RS[k], 1.85*RS[k], 0.34, [0,0,0], 0));
      pl.add(rib  (M.armor, 0.14, 1.70*RS[k], 0.14, [ 0.80*RS[k], 0, 0.22]));
      pl.add(rib  (M.armor, 0.14, 1.70*RS[k], 0.14, [-0.80*RS[k], 0, 0.22]));
      var g = mesh(G.box, GLA, [1.30*RS[k], 0.10, 0.10], [0, 0, 0.24]);
      g.userData.noMerge = 1; pl.add(g);
      plates.push({pl:pl, az:az, k:k, i:i, y0:RY[k], z0:2.70*RS[k], t0:RT[k]});
    }
  }
  root.userData.rig = {hub:hub, plates:plates, vd:vd, rim:rim, rim2:rim2, GLV:GLV, GLA:GLA};
  return mergeBones(root);
}
export function updHohlraum(rig, o, dt){
  stages(rig, o, dt, 1.6);
  var s1 = rig.s1, s2 = rig.s2, i, P;
  var ex = 1 + 0.62*s1 - 1.55*s2;                   // 貼合 → 散開 → 穿過核心
  for (i = 0; i < rig.plates.length; i++){
    P = rig.plates[i];
    var wob = 0.16*Math.sin(o.t*1.4 + i*0.9)*(0.4 + s1);
    P.pl.position.z = P.z0*ex + wob;
    P.pl.position.y = P.y0*ex;
    P.pl.rotation.x = P.t0 + Math.PI*s2 + 0.10*Math.sin(o.t*1.1 + i);
    P.az.rotation.y += dt*(0.10 + 0.55*s1 + 1.4*s2)*(P.k === 1 ? 1 : -0.7);
  }
  rig.hub.rotation.y += dt*0.18;
  rig.hub.position.y = 3.90 + 0.22*Math.sin(o.t*0.7);
  rig.vd.scale.setScalar(1 + 0.55*s1 + 1.10*s2 + 0.08*Math.sin(o.t*2.1));
  rig.rim.scale.set(1 + 0.5*s1 + 0.9*s2, 1 + 0.5*s1 + 0.9*s2, 0.34);
  rig.rim2.rotation.x += dt*0.9;
  rig.GLV.emissiveIntensity = 2.5 + 2.4*o.tel + 1.8*s2;
  rig.GLA.emissiveIntensity = 2.2*(1-0.6*s2) + 3.0*o.tel + 5*o.atk*(1-o.atk);
}